/**
 * Wrapper de compatibilidade: a rota /tenant/lists agora abre a
 * Central de Importação de Listas com a aba "Contatos" como padrão.
 *
 * A implementação real vive em src/pages/lists/ListsHub.tsx.
 */

import ListsHub from '@/pages/lists/ListsHub';

export default function Lists() {
  return <ListsHub defaultTab="contacts" />;
}
